"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var realtimeDataService_1 = require("./realtimeDataService");
var historicDataService_1 = require("./historicDataService");
var historicDataTypes_1 = require("./historicDataTypes");
var SmashDataService = /** @class */ (function () {
    function SmashDataService() {
    }
    SmashDataService.prototype.getHistoricData = function (request) {
        switch (request.type) {
            case historicDataTypes_1.HistoricDataRequestType.AfterTimeDataRequest: {
                return historicDataService_1.default.getHistoricDataAfterTime(request);
            }
        }
    };
    /**
     * {
     *    datasetId: data,
     *    ..
     *    functionKey: value,
     *    ...
     *    time
     * }
     *
     * ex)
     * {
     *    "dataset1-id" : { bidPrice: 1.30, askPrice: 1.34, ...},
     *    ...
     *    "y": 1.04,
     *    "time": 1523821670267
     * }
     * @param legend
     */
    SmashDataService.prototype.processData = function (legend, options) {
        var data = {};
        // sets dataset data
        Object.keys(legend.mappings).forEach(function (key) {
            var datasetId = legend.mappings[key].datasetId;
            data[datasetId] = realtimeDataService_1.default.getLatestData(datasetId);
        });
        if (legend.serverSideFunction) {
            legend.serverSideFunction.forEach(function (ssf) {
                // todo: handle by function. for now it's TSCaclculate function
                var datasetId = ssf.params[0];
                var latestData = Object.assign({}, realtimeDataService_1.default.getLatestData(datasetId));
                // convert realtime data type to server side data type
                latestData.value = latestData[ssf.params[1]];
                data[ssf.requestId] = latestData;
            });
        }
        // evaluate functions
        Object.keys(legend.functions).forEach(function (key) {
            var value = null;
            try {
                value = legend.functions[key](data);
            }
            catch (e) {
                // Do not need to handle this exception.
                console.log('Function evaluation error.');
            }
            data[key] = value;
        });
        return data;
    };
    return SmashDataService;
}());
var instance = new SmashDataService();
exports.default = instance;
//# sourceMappingURL=dataService.js.map


// WEBPACK FOOTER //
// ./src/core/services/data/dataService.js